const geography = () => {
  gsap.registerPlugin(ScrollTrigger);

  /* Инициализация анимации */
  initGsapGeography('.geography__list--top', false);
  initGsapGeography('.geography__list--mid', true);
  initGsapGeography('.geography__list--bottom', false);
  

  /* Настройка параметров для анимации */
  function initGsapGeography(block, status) {
    const motion = status ? "25%" : "-25%";
    gsap.to(block, {
      scrollTrigger: {
        trigger: ".geography",
        start: "-400px bottom",
        end: "bottom -1000px",
        scrub: !0,
        toggleActions: "restart pause reverse pause"
      },
      x: motion,
      ease: "none",
      duration: 4e3
    });
  }
};

export default geography;


